module.exports = __webpack_public_path__ + "static/media/logo.bb1ae109.png";